import React from 'react'
import PropTypes from 'prop-types'
import { getLocales } from '../../utilities/locales'
import translate from '../../utilities/translate'
import translations from './translations'

// trans :: String -> String -> String
const trans = translate(translations)

// TikTok :: Props -> React.Component
const TikTok = ({ locale, src, sourceUrl }) =>
  <iframe
    data-is="component-tiktok"
    data-source={ sourceUrl }
    src={ src }
    allowFullScreen={ true }
    title={ trans(locale)('title') }
  />

TikTok.propTypes = {
  locale: PropTypes.oneOf(getLocales()).isRequired,
  sourceUrl: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
}

export default TikTok
